
import { reachGoal } from './utils/metrika.js';
export default {
    name: 'MeatPageHeader',
    props: {
        header: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            isBurgerOpen: false,
            isHidden: false,    
            isScrolled: false,
            lastScroll: 0,      
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    beforeDestroy() {
        this.setBurgerOpen(false);
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        reachGoal,
        handleMenuClick(element) {
            this.reachGoal('click_nav', element);
            this.setBurgerOpen(false); 
            this.$router.push(element.href);
        },
        handleLangClick(element) {
            this.reachGoal('click_lang', element);
            this.setBurgerOpen(false);
            this.$router.push(element.href);
        },
        handleScroll() {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

            if (this.isBurgerOpen) return;

            this.isScrolled = currentScroll > 50;

            if (currentScroll > this.lastScroll && currentScroll > 100) {
                this.isHidden = true;
            } else {
                this.isHidden = false;
            }

            this.lastScroll = currentScroll <= 0 ? 0 : currentScroll;
        },
        setBurgerOpen(open = true) {
            this.isBurgerOpen = open;

            if (open) this.isHidden = false;
            document.documentElement.classList.toggle('overflow', this.isBurgerOpen);
        }
    }
}
